function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.357 5.723c-.392.392-.588.588-.823.631a.77.77 0 01-.28 0c-.235-.043-.43-.24-.822-.63l-1.155-1.156c-.392-.391-.588-.587-.631-.822a.77.77 0 010-.28c.043-.235.24-.431.63-.823.392-.391.588-.587.824-.63a.77.77 0 01.279 0c.235.043.431.239.823.63l1.155 1.155c.391.392.587.588.63.823a.767.767 0 010 .28c-.043.235-.239.43-.63.822zM3.54 14c-.726 0-1.089 0-1.314-.226C2 13.55 2 13.187 2 12.46v-.902c0-.315 0-.472.059-.614.058-.14.17-.252.392-.475l5.005-5.004c.513-.514.77-.77 1.088-.77.32 0 .576.256 1.09.77l.901.902c.514.513.77.77.77 1.089 0 .318-.256.575-.77 1.088L5.531 13.55c-.223.223-.334.334-.476.392-.141.059-.298.059-.613.059H3.54z",
  fill: "#5C6A79"
});

var SvgEditSmall = function SvgEditSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgEditSmall;